import { useState } from 'react';
import { useInterval, useMount } from 'react-use';
import styled from 'styled-components';

import { PharmindexIntegrationInfoQuery } from '@dreryk/medicine-database-pharmindex-api';

import { Slot } from '@dreryk/watermelon';
import { performCqrsQueryExists } from '@dreryk/command-query-react-common';

import { PharmindexIntegrationStatusTable } from './PharmindexIntegrationStatusTable';
import StartIntegrationButton from './StartIntegrationButton';

const CHECK_INTEGRATION_PROGRESS_INTERVAL_IN_MILLISECONDS = 10000;

const StyledPharmindexIntegrationPanel = styled.div`
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   overflow: auto;

   & > * {
      margin-bottom: 0.5em;
   }
`;
StyledPharmindexIntegrationPanel.displayName = 'StyledPharmindexIntegrationPanel';

export type HandleSetIntegrationInProgress = (on: boolean) => void;

const checkIntegrationInProgress = async (): Promise<boolean> => {
   return performCqrsQueryExists(() => {
      const query = new PharmindexIntegrationInfoQuery();
      query.status = Slot.of('STARTED');
      return query;
   });
};

const PharmindexIntegrationPanel = (): JSX.Element => {
   const [integrationInProgress, setIntegrationInProgress] = useState(false);

   const handleSetIntegrationInProgress = (on: boolean): void => {
      setIntegrationInProgress(on);
   };

   useMount(() => {
      checkIntegrationInProgress().then(handleSetIntegrationInProgress);
   });

   useInterval(() => {
      checkIntegrationInProgress().then(handleSetIntegrationInProgress);
   }, CHECK_INTEGRATION_PROGRESS_INTERVAL_IN_MILLISECONDS);

   return (
      <StyledPharmindexIntegrationPanel>
         <div>
            <StartIntegrationButton
               integrationInProgress={integrationInProgress}
               handleSetIntegrationInProgress={handleSetIntegrationInProgress}
            />
         </div>
         <PharmindexIntegrationStatusTable />
      </StyledPharmindexIntegrationPanel>
   );
};
export { PharmindexIntegrationPanel };
